export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Ero terrorizzato dalla riabilitazione della spalla. Tutte le fasi sembravano impossibili. Dopo 5 giorni con Atleta 360™, ho strutturato il mio primo protocollo completo. Alla settimana 3, i miei atleti erano già tornati alla panca piana in totale fiducia.',
    name: 'Marco T.',
    location: 'Milano · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/aec5b321-5a5d-489b-bcc6-6865bdbaab55.jpg',
  },
  {
    quote:
      'Gestivo infortuni al ginocchio da 2 anni, frustrata perché i clienti si infortunavano di nuovo. Il PROTOCOLLO ATLETA 360 funziona davvero. Ora seguo 15 clienti con progressioni sicure e scientifiche.',
    name: 'Sofia L.',
    location: 'Roma · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/ee891553-0211-4ce9-b617-31a7c8db5a65.jpg',
  },
  {
    quote:
      "Avevo paura di non essere 'abbastanza bravo' per gestire infortuni complessi. SIGMA SMART™ mi ha dimostrato il contrario. Il metodo visivo rende tutto cristallino. Mi sono sentito sicuro fin dal PRIMO GIORNO.",
    name: 'Davide P.',
    location: 'Lugano · Svizzera',
    flag: '🇨🇭',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/fdfa5a05-54c8-441c-b750-f5d2dd73c2c4.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'Le schede di monitoraggio stampabili sono diventate il mio strumento principale in studio. So esattamente quando progredire con il carico. I pazienti tornano meno spesso per recidive.',
    name: 'Giulio R.',
    location: 'Torino · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/41af9aa0-ce37-4d6b-a1f9-5a0e884ebf9b.jpg',
  },
  {
    quote:
      'Vedere ogni fase spiegata visivamente ha cambiato tutto. La chiarezza del protocollo SIGMA SMART™ non ha eguali sul mercato italiano.',
    name: 'Emma T.',
    location: 'Napoli · Italia',
    flag: '🇮🇹',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/0c3cb8cb-eded-48d0-b2af-f7e4a83d000d.jpg',
  },
];
